// Vendor Libs
import {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

// Redux Actions
import {deleteRecord, deleteRecordReset} from '../actions/delete-record-actions';

class Deletable extends Component {
    state = {
        deleteConfirm: false,
        deleteCompleted: false,
    };

    componentDidUpdate(nextProps) {
        const {recordId} = this.props;

        if (recordId !== nextProps.recordId) {
            this.resetDelete();
        }
    }

    handleConfirmClick = () => {
        const {deleteRecord, recordId, formName} = this.props;

        deleteRecord(recordId, formName, 'Successfully Deleted').then(() => {
            this.setState({deleteConfirm: false, deleteCompleted: true});
        });
    };

    handleResetClick = () => {
        this.resetDelete(true);
    };

    handleDeleteClick = () => {
        this.setState({deleteConfirm: true, deleteCompleted: false});
    };

    resetDelete = (resetForm = false) => {
        const {deleteRecordReset, formName} = this.props;

        deleteRecordReset(formName, resetForm);
        this.setState({deleteConfirm: false, deleteCompleted: false});
    };

    shouldRenderDeleteButton = () => {
        const {deleteCompleted, deleteConfirm} = this.state;

        return !deleteConfirm && !deleteCompleted;
    };

    shouldRenderConfirm = () => {
        const {deleteCompleted, deleteConfirm} = this.state;

        return deleteConfirm || deleteCompleted;
    };

    getRenderProps = () => {
        const {status} = this.props;

        return {
            ...this.state,
            handleDeleteClick: this.handleDeleteClick,
            status,
            handleConfirmClick: this.handleConfirmClick,
            handleResetClick: this.handleResetClick,
            resetDelete: this.resetDelete,
            shouldRenderConfirm: this.shouldRenderConfirm,
            shouldRenderDeleteButton: this.shouldRenderDeleteButton,
        };
    };

    render() {
        const {children} = this.props;

        return children ? children(this.getRenderProps()) : null;
    }
}

Deletable.propTypes = {
    children: PropTypes.func,
    deleteRecord: PropTypes.func.isRequired,
    deleteRecordReset: PropTypes.func.isRequired,
    formName: PropTypes.string.isRequired,
    recordId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    status: PropTypes.object,
};

const mapStateToProps = (state) => ({
    status: state.deleteRecord,
});

const mapDispatchToProps = {
    deleteRecord,
    deleteRecordReset,
};

export default connect(mapStateToProps, mapDispatchToProps)(Deletable);
